import { createSelector } from '@reduxjs/toolkit';

import { IState } from '../../store';
import { ICoworkingAmenitiesGroup } from '../../types/coworkingAmenities';

const getCoworkingIncludedAmenities = (state: IState) => state.offerData.coworkingIncludedAmenities || [];

export const selectCoworkingIncludedAmenities = createSelector(
  [getCoworkingIncludedAmenities],
  (amenitiesGroups: ICoworkingAmenitiesGroup[]): ICoworkingAmenitiesGroup[] => {
    return amenitiesGroups.reduce((acc, currentItem) => {
      const filteredAmenities = currentItem.amenities.filter(({ isAvailable }) => isAvailable);

      if (filteredAmenities.length) {
        return [
          ...acc,
          {
            ...currentItem,
            amenities: filteredAmenities,
          },
        ];
      }

      return acc;
    }, []);
  },
);
